export enum QueryType {
  SIMPLE_PRODUCT_SEARCH = 'SIMPLE_PRODUCT_SEARCH',
  ORDER_SUPPORT = 'ORDER_SUPPORT'
}
